import FJCommunityHome from './FJCommunityHome';
import useLocalStore from '../../../../hooks/useLocalStore';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';
import FJActionCommunity from '../../../../redux/action/FJActionCommunity';
import { useDispatch } from 'react-redux';
import FJConstant from '../../../../constants/FJConstant';
import { useCallback } from 'react';
const FJCommunityHomeContainer = props => {
    const dispatch = useDispatch();
    useLocalStore();
    const { active, embedded } = props;
    const homeList = useSelector(state => state.community.homeList);
    const communityList = useSelector(state => state.community.communityList); // 如果是嵌入，使用communityList列表数据
    const homePageInfo = useSelector(state => state.community.homePageInfo);
    const communityPageInfo = useSelector(state => state.community.communityPageInfo);
    const list = useMemo(() => {
        if (embedded) {
            return communityList;
        } else {
            return homeList;
        }
    }, [embedded, communityList, homeList]);
    const pageInfo = useMemo(() => {
        if (embedded) {
            return communityPageInfo;
        } else {
            return homePageInfo;
        }
    }, [embedded, communityPageInfo, homePageInfo]);
    useEffect(() => {
        if (embedded) {
            dispatch(FJActionCommunity.initCommunityListAction());
        } else {
            dispatch(FJActionCommunity.initHomeListAction());
        }
    }, [dispatch, embedded]);
    const _getMoreData = useCallback(() => {
        if (embedded) {
            dispatch(FJActionCommunity.getMoreCommunityListAction());
        } else {
            dispatch(FJActionCommunity.getMoreHomeListAction());
        }
    }, [dispatch, embedded]);
    const _onSeeAllClick = useCallback(() => {
        dispatch(FJActionCommunity.changeNavBarTabAction(FJConstant.AI_TOOL_LIST));
    }, [dispatch]);
    return (
        <FJCommunityHome
            active={active}
            list={list}
            getMoreData={_getMoreData}
            pageInfo={pageInfo}
            embedded={embedded}
            onSeeAllClick={_onSeeAllClick}
        />
    );
};

FJCommunityHomeContainer.propTypes = {
    active: PropTypes.bool.isRequired,
    embedded: PropTypes.bool,
};

export default FJCommunityHomeContainer;
